/**
 * switchHandles.ts
 * Switchカードの入出力ハンドルID定義
 */
export const SWITCH_SOURCE_HANDLES = {
  match1: 'switch-match-1',
  match2: 'switch-match-2',
  default: 'switch-default',
} as const;
